const clientTypes = {
  GET_ALL_CLIENTS_SUCCESS: 'GET_ALL_CLIENTS_SUCCESS',
  GET_ALL_CLIENTS_FAILURE: 'GET_ALL_CLIENTS_FAILURE',
};

export default clientTypes;
